import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractList3ck35puwbp1e9 as AbstractList } from './AbstractList.mjs';
import { AbstractMutableList192xfq8ycgofs as AbstractMutableList } from './AbstractMutableListJs.mjs';
import { IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException } from '../exceptions.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from './CollectionsKt.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function asReversed(_this__u8e3s4) {
  return ReversedListReadOnly().new_kotlin_collections_ReversedListReadOnly_s1exex_k$(_this__u8e3s4);
}
function asReversed_0(_this__u8e3s4) {
  return ReversedList().new_kotlin_collections_ReversedList_rbz3qk_k$(_this__u8e3s4);
}
var ReversedListReadOnly$listIterator$1Class;
function ReversedListReadOnly$listIterator$1() {
  if (ReversedListReadOnly$listIterator$1Class === VOID) {
    class $ {
      constructor(this$0, $index) {
        this.this$0__1 = this$0;
        this.delegateIterator_1 = this$0.delegate_1.listIterator_70e65o_k$(reversePositionIndex(this$0, $index));
      }
      hasNext_bitz1p_k$() {
        return this.delegateIterator_1.hasPrevious_qh0629_k$();
      }
      hasPrevious_qh0629_k$() {
        return this.delegateIterator_1.hasNext_bitz1p_k$();
      }
      next_20eer_k$() {
        return this.delegateIterator_1.previous_l2dfd5_k$();
      }
      previous_l2dfd5_k$() {
        return this.delegateIterator_1.next_20eer_k$();
      }
    }
    initMetadataForClass($);
    ReversedListReadOnly$listIterator$1Class = $;
  }
  return ReversedListReadOnly$listIterator$1Class;
}
var ReversedListReadOnlyClass;
function ReversedListReadOnly() {
  if (ReversedListReadOnlyClass === VOID) {
    class $ extends AbstractList() {
      constructor(delegate) {
        return new.target.new_kotlin_collections_ReversedListReadOnly_s1exex_k$(delegate);
      }
      static new_kotlin_collections_ReversedListReadOnly_s1exex_k$(delegate) {
        var $this = this.new_kotlin_collections_AbstractList_7zpyyf_k$();
        $this.delegate_1 = delegate;
        return $this;
      }
      get_size_woubt6_k$() {
        return this.delegate_1.get_size_woubt6_k$();
      }
      get_c1px32_k$(index) {
        return this.delegate_1.get_c1px32_k$(reverseElementIndex(this, index));
      }
      iterator_jk1svi_k$() {
        return this.listIterator_70e65o_k$(0);
      }
      listIterator_70e65o_k$(index) {
        return new (ReversedListReadOnly$listIterator$1())(this, index);
      }
    }
    initMetadataForClass($, 'ReversedListReadOnly');
    ReversedListReadOnlyClass = $;
  }
  return ReversedListReadOnlyClass;
}
var ReversedList$listIterator$1Class;
function ReversedList$listIterator$1() {
  if (ReversedList$listIterator$1Class === VOID) {
    class $ {
      constructor(this$0, $index) {
        this.this$0__1 = this$0;
        this.delegateIterator_1 = this$0.delegate_1.listIterator_70e65o_k$(reversePositionIndex(this$0, $index));
      }
      hasNext_bitz1p_k$() {
        return this.delegateIterator_1.hasPrevious_qh0629_k$();
      }
      hasPrevious_qh0629_k$() {
        return this.delegateIterator_1.hasNext_bitz1p_k$();
      }
      next_20eer_k$() {
        return this.delegateIterator_1.previous_l2dfd5_k$();
      }
      previous_l2dfd5_k$() {
        return this.delegateIterator_1.next_20eer_k$();
      }
      remove_ldkf9o_k$() {
        return this.delegateIterator_1.remove_ldkf9o_k$();
      }
    }
    initMetadataForClass($);
    ReversedList$listIterator$1Class = $;
  }
  return ReversedList$listIterator$1Class;
}
var ReversedListClass;
function ReversedList() {
  if (ReversedListClass === VOID) {
    class $ extends AbstractMutableList() {
      constructor(delegate) {
        return new.target.new_kotlin_collections_ReversedList_rbz3qk_k$(delegate);
      }
      static new_kotlin_collections_ReversedList_rbz3qk_k$(delegate) {
        var $this = this.new_kotlin_collections_AbstractMutableList_ddn594_k$();
        $this.delegate_1 = delegate;
        return $this;
      }
      get_size_woubt6_k$() {
        return this.delegate_1.get_size_woubt6_k$();
      }
      get_c1px32_k$(index) {
        return this.delegate_1.get_c1px32_k$(reverseElementIndex(this, index));
      }
      clear_j9egeb_k$() {
        return this.delegate_1.clear_j9egeb_k$();
      }
      removeAt_6niowx_k$(index) {
        return this.delegate_1.removeAt_6niowx_k$(reverseElementIndex(this, index));
      }
      set_9t5s9l_k$(index, element) {
        return this.delegate_1.set_82063s_k$(reverseElementIndex(this, index), element);
      }
      set_82063s_k$(index, element) {
        return this.set_9t5s9l_k$(index, element);
      }
      add_gaf1mg_k$(index, element) {
        this.delegate_1.add_dl6gt3_k$(reversePositionIndex(this, index), element);
      }
      add_dl6gt3_k$(index, element) {
        return this.add_gaf1mg_k$(index, element);
      }
      iterator_jk1svi_k$() {
        return this.listIterator_70e65o_k$(0);
      }
      listIterator_70e65o_k$(index) {
        return new (ReversedList$listIterator$1())(this, index);
      }
    }
    initMetadataForClass($, 'ReversedList');
    ReversedListClass = $;
  }
  return ReversedListClass;
}
function reverseElementIndex(_this__u8e3s4, index) {
  var tmp;
  if (0 <= index ? index <= get_lastIndex(_this__u8e3s4) : false) {
    tmp = get_lastIndex(_this__u8e3s4) - index | 0;
  } else {
    throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('Element index ' + index + ' must be in range [' + numberRangeToNumber(0, get_lastIndex(_this__u8e3s4)).toString() + '].');
  }
  return tmp;
}
function reversePositionIndex(_this__u8e3s4, index) {
  var tmp;
  if (0 <= index ? index <= _this__u8e3s4.get_size_woubt6_k$() : false) {
    tmp = _this__u8e3s4.get_size_woubt6_k$() - index | 0;
  } else {
    throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('Position index ' + index + ' must be in range [' + numberRangeToNumber(0, _this__u8e3s4.get_size_woubt6_k$()).toString() + '].');
  }
  return tmp;
}
//region block: exports
export {
  asReversed_0 as asReversed2y2qzr7vrqd5,
  asReversed as asReversed308kw52j6ls1u,
};
//endregion

//# sourceMappingURL=ReversedViews.mjs.map
